"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = isValidEmail;
exports.isValidPhoneNumber = isValidPhoneNumber;
exports.isValidWebsite = isValidWebsite;
var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var PHONE_PATTERN = /^\+?[\d\s()-]{7,}$/;
var WEBSITE_PATTERN = /^\S+\.\S+$/;
function isValidEmail(value) {
    return EMAIL_PATTERN.test(value);
}
function isValidPhoneNumber(value) {
    return PHONE_PATTERN.test(value);
}
function isValidWebsite(value) {
    return WEBSITE_PATTERN.test(value);
}
